import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    //设置属性
    defaultSearchData:'',
    defaultRadio:''
  },
  mutations: {
    //
    changeDefaultSearchData(state,str){
        state.defaultSearchData = str.i;
        state.defaultRadio = str.o;
        console.log(str)
    }
  },
  actions: {},
  modules: {}
});
